import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import api from "@/lib/api";

// Fetches /subscription/config and reports whether the current viewer is
// blocked from the full ranking & leaderboard pages.
export function useSubscriberGate() {
  const [gate, setGate] = useState(null);
  useEffect(() => {
    api.get("/subscription/config")
      .then(({ data }) => setGate(data))
      .catch(() => setGate({ leaderboards_gated: false, has_leaderboard_access: true }));
  }, []);
  const loading = gate === null;
  const blocked = !loading && gate.leaderboards_gated && !gate.has_leaderboard_access;
  return { loading, blocked, message: gate?.upsell_message };
}

export function GateScreen({ message }) {
  return (
    <div data-testid="subscription-gate" className="bg-white border border-slate-200 p-12 text-center max-w-xl mx-auto rounded-sm">
      <Lock className="w-12 h-12 mx-auto text-[#E63946]" />
      <div className="font-display text-2xl uppercase mt-4">Members Only</div>
      <p className="text-sm text-slate-600 mt-2">{message || "Full rankings & leaderboards are available to CBR Prospects members."}</p>
      <Link to="/membership" data-testid="gate-upgrade-cta" className="inline-flex items-center gap-2 bg-[#E63946] hover:bg-[#D90429] text-white px-6 py-3 mt-6 text-sm font-semibold uppercase tracking-wider rounded-sm">Become a Member</Link>
    </div>
  );
}
